<template>
  <b-container class="profilo">
    <b-row v-if="profilo.isLoggedUser">
      <b-col cols="12" class="text-center">
        <b-button variant="outline-dark" :to="{ name: 'ModificaProfilo' }">
          Modifica profilo
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-4">
        <b-col sm="4">
            <b-img :src="getAvatarUrl()" width="150" fluid alt="Immagine profilo"></b-img>
            <b-row>
                <b-col cols="12" class="text-center mb-1 mt-3" v-if="profilo.facebook || profilo.twitter || profilo.linkedin">
                  Social dell'avvocato:
                </b-col>
                <b-col cols="12" class="text-center my-1">
                    <b-button :href="profilo.facebook" class="facebook" v-if="profilo.facebook" target="_blank">
                      <font-awesome-icon :icon="['fab', 'facebook']" />
                    </b-button>
                    <b-button :href="profilo.twitter" class="twitter" v-if="profilo.twitter" target="_blank">
                      <font-awesome-icon :icon="['fab', 'twitter']" />
                    </b-button>
                    <b-button :href="profilo.linkedin" class="linkedin" v-if="profilo.linkedin" target="_blank">
                      <font-awesome-icon :icon="['fab', 'linkedin']" />
                    </b-button>
                </b-col>
                <b-col cols="12" class="my-1">
                    <b-button :href="profilo.sitoWeb" v-if="profilo.sitoWeb" target="_blank">
                      Sito web
                      <font-awesome-icon icon="external-link-alt" />
                    </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" class="text-center mt-3">
                    <p class="text-monospace" v-html="cleanHtml(profilo.descrizione)"></p>
                </b-col>
            </b-row>
        </b-col>
        <b-col sm="8" class="text-left">
            <b-row>
                <b-col>
                    <h4><b class="text-uppercase">
                      {{profilo.titoloAbbreviato}} {{profilo.nome}} {{profilo.cognome}}
                    </b></h4>
                </b-col>
                <b-col>
                    <b-button size="sm" v-if="profilo.hasCV" :href="getCvUrl()" target="_blank">
                        Scarica il CV
                        <font-awesome-icon icon="paperclip" />
                    </b-button>
                </b-col>
            </b-row>
            <hr/>
            <b-row class="my-1" v-if="profilo.avvocato">
                <b-col cols="6" sm="3">
                    <font-awesome-icon icon="user-graduate" /> 
                    Ordine di appartenenza:
                </b-col>
                <b-col cols="6" sm="3">
                  <b>{{profilo.ordineDiAppartenenza}}</b>
                </b-col>
                <b-col cols="6" sm="3">
                    <font-awesome-icon icon="calendar-day" />
                    Anno di iscrizione all'ordine:
                </b-col>
                <b-col cols="6" sm="3" v-if="profilo.annoIscrizoneOrdine > 0">
                  <b>{{profilo.annoIscrizoneOrdine}}</b>
                </b-col>                
            </b-row>
            <b-row class="my-1">
                <b-col cols="6" sm="3">
                    <font-awesome-icon icon="at" />
                    Email:
                </b-col>
                <b-col cols="6" sm="3" class="text-break">
                  <b>{{profilo.email}}</b>
                </b-col>
                <b-col cols="6" sm="3">
                    <font-awesome-icon icon="envelope" />
                    PEC:
                </b-col>
                <b-col cols="6" sm="3" class="text-break">
                  <b>{{profilo.pec}}</b>
                </b-col>                
            </b-row>
            <b-row class="my-1" v-if="profilo.avvocato">
                <b-col cols="9">
                    <font-awesome-icon icon="stamp" />
                    Abilitazione al patrocinio dinanzi alle Giurisdizioni Superiori:
                </b-col>
                <b-col cols="3">
                  <b>{{profilo.abilitazionePatrocinio ? 'Sì' : 'No'}}</b>
                </b-col>           
            </b-row>
            <hr/>
            <b-row v-if="profilo.avvocato">
                <b-col cols="12 text-center mb-1">
                    <b>Sede principale dello studio</b>
                </b-col>
                <b-col sm="6">
                    <font-awesome-icon icon="map-marker-alt" />
                    Indirizzo:
                    <b>{{profilo.sedePrincipaleVia}} {{profilo.sedePrincipaleCivico}}, {{profilo.sedePrincipaleCap}} {{profilo.sedePrincipaleCitta}}</b>
                </b-col>
                <b-col sm="6">
                    <font-awesome-icon icon="phone" />
                    Telefono:
                    <b>{{profilo.sedePrincipaleTelefono}}</b>
                </b-col>
            </b-row>
            <b-row v-if="profilo.avvocato">
                <b-col cols="12 text-center mb-1 mt-3">
                    <b>Sede secondaria dello studio</b>
                </b-col>
                <b-col sm="6">
                    <font-awesome-icon icon="map-marker-alt" />
                    Indirizzo:
                    <b>{{profilo.sedeSecondarialeVia}} {{profilo.sedeSecondariaCivico}}, {{profilo.sedeSecondariaCap}} {{profilo.sedeSecondariaCitta}}</b>
                </b-col>
                <b-col sm="6">
                    <font-awesome-icon icon="phone" />
                    Telefono:
                    <b>{{profilo.sedeSecondariaTelefono}}</b>
                </b-col>
            </b-row>
            <hr/>
            <b-row>
                <b-col sm="6">
                    <font-awesome-icon icon="hashtag" />
                    Totale sentenze massimate o commentate:
                    <b>{{profilo.numeroCommenti}}</b>
                </b-col>
                <b-col sm="6">
                    <font-awesome-icon icon="calendar-day" />
                    Registrato su GiustUp il: 
                    <b>{{profilo.dataRegistrazione}}</b>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
    <hr/>
    <b-row class="mt-4">
        <b-col cols="12">
            <h5 class="mb-1"><b>Sentenze commentate o massimate:</b></h5>
            <p class="mt-2" v-if="commenti.length == 0">Nessuna sentenza commentata o massimata!</p>
            <b-list-group>
              <b-list-group-item v-for="commento of commenti" :key="commento.id" :value="commento.id" class="flex-column align-items-start">
                <div class="d-flex w-100 justify-content-between">
                <router-link :to="{ name: 'Sentenza', params: { idNodo: commento.sentenzaId } }">
                  <h5 class="mb-1 font-weight-bold">{{commento.sentenzaTitolo}}</h5>           
                </router-link>

                <small>{{formatDate(new Date(commento.dataInserimento))}}</small>
                </div>

                <div class="text-justify mb-1 mt-3" v-html="cleanHtml(commento.premassima)"></div>
                
                <small class="float-left">Piace a {{commento.numeroLike}} persone; {{commento.numeroVisualizzazioni}} persone hanno visualizzato la sentenza</small>
              </b-list-group-item>

            </b-list-group>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
import api from '../../services/service.js'

export default {
  name: 'profilo',
  data () {
    return {
      codFisc: this.$route.params.codFisc,
      profilo: {},
      commenti: []
    }
  },
  methods: {
    getAvatarUrl(){
      return api.getBaseUrl() + 'utente/' + this.codFisc + '/immagine?nocache=' + Math.random();
    },
    getCvUrl(){
      return api.getBaseUrl() + 'utente/' + this.codFisc + '/cv';
    },
    async getUser(){
      let data = await api.execute('get', 'profilo/' + this.codFisc);
      this.profilo = data;
    },
    async getCommenti(){
      let data = await api.execute('get', 'profilo/' + this.codFisc + '/commenti');
      this.commenti = data;
    },
    formatDate(d) {
      return ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
          d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    },
    cleanHtml(html){
      if(html === null || html === undefined)
        return null;
      return html.split('&nbsp;').join(' ');
    }
  },
  async created() {
    await api.execute('get', 'utente/info');

    await this.getUser();
    await this.getCommenti();

    this.$parent._data.loaded = true;
  }
}
</script>

<style>
@import '../social.css';
</style>



// WEBPACK FOOTER //
// src/components/Utente/Profilo.vue